import React, { useMemo } from "react";
import Skeleton from "../../../../components/skeleton";

/**
 * Skeleton loader for the alphabet letters grid in Drugs & Diseases.
 * @returns {JSX.Element} The skeleton component for letters.
 */
const SkeletonLetters: React.FC = () => {
  return useMemo(
    () => (
      <div className="grid grid-cols-6 gap-2 mb-6">
        {Array.from({ length: 12 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-full rounded-lg" />
        ))}
      </div>
    ),
    [],
  );
};

export default SkeletonLetters;
